const ACCESS_TOKEN_KEY = 'elite_core_access_token';
const LEGACY_TOKEN_KEYS = ['auth_token', 'business_bloc_token', 'accessToken'] as const;

let inMemoryAccessToken: string | null = null;

const readSessionStorage = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (_error) {
    return null;
  }
};

const writeSessionStorage = (key: string, value: string) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (_error) {
    inMemoryAccessToken = value;
  }
};

const removeSessionStorage = (key: string) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (_error) {
    // Ignore storage removal failures in restricted browsers.
  }
};

const readLegacyStorage = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch (_error) {
    return null;
  }
};

const clearLegacyStorage = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (_error) {
    // Ignore storage removal failures in restricted browsers.
  }
};

const migrateLegacyToken = (): string | null => {
  for (const legacyKey of LEGACY_TOKEN_KEYS) {
    const token = readLegacyStorage(legacyKey);
    if (!token) {
      continue;
    }

    writeSessionStorage(ACCESS_TOKEN_KEY, token);
    inMemoryAccessToken = token;
    LEGACY_TOKEN_KEYS.forEach(clearLegacyStorage);
    clearLegacyStorage(ACCESS_TOKEN_KEY);
    return token;
  }

  return null;
};

export const getAccessToken = (): string | null => {
  const canonicalToken = readSessionStorage(ACCESS_TOKEN_KEY);
  if (canonicalToken) {
    inMemoryAccessToken = canonicalToken;
    return canonicalToken;
  }

  if (inMemoryAccessToken) {
    return inMemoryAccessToken;
  }

  return migrateLegacyToken();
};

export const setAccessToken = (token: string) => {
  inMemoryAccessToken = token;
  writeSessionStorage(ACCESS_TOKEN_KEY, token);
  clearLegacyStorage(ACCESS_TOKEN_KEY);
  LEGACY_TOKEN_KEYS.forEach(clearLegacyStorage);
};

export const clearAccessToken = () => {
  inMemoryAccessToken = null;
  removeSessionStorage(ACCESS_TOKEN_KEY);
  clearLegacyStorage(ACCESS_TOKEN_KEY);
  LEGACY_TOKEN_KEYS.forEach(clearLegacyStorage);
};

export { ACCESS_TOKEN_KEY };
